import React from 'react';
import {
    Box,
    Heading,
    ResponsiveContext,
    Text,
} from "grommet";
import { getSimpleDateFR, isPhone, toCurrency } from '../../../services/utils';
import moment from 'moment';
import { ABONNEMENT, CLIENT_TYPE, PRODUCT, RESIDENCE_TYPE } from '../../../services/types';
import Promo from '../../promo';
import PrimaryButton from '../../elements/button';
import { getFirstPayAmount } from '../../../services/services';
import translate from '../../../i18n/translate';

const Info = ({ field, value }) => {
    return (
        <Box direction='row'>
            <Box style={{ width: '100%' }}>
                <Text style={{ color: '#707070' }}>{field}: </Text>
            </Box>
            <Box style={{ width: '100%' }}>
                <Text style={{ fontWeight: 'bold', color: '#707070', marginLeft: 2 }}> {value}</Text>
            </Box>
        </Box>
    );
}

const Recap = ({ devis, product, onDevisChange, toStartStep, checkout, submitable = true }) => {

    const isMH = product === PRODUCT.MH;
    const isMHTEMPO = product === PRODUCT.MH_TEMPO;
    const isMonthly = devis.abonnement === ABONNEMENT.monthly;

    return (
        <ResponsiveContext.Consumer>
            {size =>
            (<Box align='center' justify='center' gap='small' pad={'small'}>
                <Box width={'large'} gap='medium' align='center'>
                    <Heading level="2" textAlign="center">{translate('recapitulatif')}</Heading>
                    <Box direction={'column'} width='full'>
                        <Box direction='column' style={{ width: '100%' }}>
                            <Heading level="3" alignSelf="center" textAlign='center' style={{ color: '#707070', fontWeight: 'bold' }}>
                                {translate('info_assure')}
                            </Heading>
                            <Info
                                field={translate('prenom')}
                                value={devis.client?.firstname}
                            />
                            <Info
                                field={translate('nom')}
                                value={devis.client?.lastname}
                            />
                            <Info
                                field='Mail'
                                value={devis.client?.email}
                            />
                            <Info
                                field={translate('phone')}
                                value={devis.client?.phone}
                            />
                            <Info
                                field={translate('adresse_postal')}
                                value={`${devis.client?.address}, ${devis.client?.zip}, ${devis.client?.city}`}
                            />
                        </Box>
                        <Box direction='column' style={{ width: '100%' }}>
                            <Heading level="3" alignSelf="center" textAlign='center' style={{ color: '#707070', fontWeight: 'bold' }}>
                                {isMH ? translate('info_habitation') : translate('info_pno')}
                            </Heading>
                            <Info
                                field={translate('logement_type')}
                                value={devis.bienType}
                            />
                            <Info
                                field={isMH ? translate('adresse_du_risque') : translate('adresse_du_risque')}
                                value={`${devis.address}, ${devis.zip}, ${devis.city}`}
                            />
                            <Info
                                field={translate('recap_nb_piece')}
                                value={devis.totalRooms}
                            />
                            <Info
                                field={translate('recap_surface')}
                                value={devis.surface}
                            />
                            {isMH &&
                                <Box direction='column' style={{ width: '100%' }}>
                                    <Info
                                        field={translate('recap_type_client')}
                                        value={translate(Object.keys(CLIENT_TYPE).find(key => CLIENT_TYPE[key] === devis.clientType) + '_recap')}
                                    />

                                    <Info
                                        field={translate('recap_nature')}
                                        value={translate(Object.keys(RESIDENCE_TYPE).find(key => RESIDENCE_TYPE[key] === devis.residenceType))}
                                    />
                                </Box>
                            }

                            {isMHTEMPO ?
                                <Info field={translate('recap_capital_mobilier')} value={toCurrency(devis.rawResponse?.capital_mobilier)} /> :
                                <Info field={translate('recap_capital_mobilier')} value={toCurrency(devis.capitalMobilier)} />
                            }

                            <Info field={translate('date_effet')} value={new Date(devis.effectiveDate || moment().add(1, 'day').toDate()).toLocaleDateString('FR-fr')} />
                            {isMHTEMPO &&
                                <Info field={translate('date_fin')} value={getSimpleDateFR(devis.date_fin)} />
                            }
                        </Box>
                        {isMH &&
                            <Box direction='column' style={{ width: '100%' }}>
                                <Heading level="3" alignSelf="center" style={{ color: '#707070', fontWeight: 'bold' }}>
                                    {translate('garanties')}
                                </Heading>
                                <Info field={translate('recap_ojet_valeur')} value={devis.option === 'Trusti base' ? toCurrency(0.1 * devis.minCapitalMobilier) : toCurrency(0.2 * devis.maxCapitalMobilier)} />
                                <Info field={translate('Franchise')} value={toCurrency(devis.franchise)} />
                            </Box>
                        }
                        {isMHTEMPO &&
                            <Box direction='column' style={{ width: '100%' }}>
                                <Heading level="3" alignSelf="center" style={{ color: '#707070', fontWeight: 'bold' }}>
                                    {translate('garanties')}
                                </Heading>
                                <Info field={translate('recap_ojet_valeur')} value={toCurrency(parseFloat(devis.rawResponse?.object_valeur))} />
                                <Info field={translate('Franchise')} value={toCurrency(153.35)} />
                            </Box>
                        }
                    </Box>

                    {isMHTEMPO ?
                        <Heading level={3} color={'#707070'}>
                            {translate('prix_enleve')}
                            <span style={{ color: "#59A4F4" }}><strong>{` ${toCurrency(getFirstPayAmount(devis))} `} </strong></span>
                        </Heading> :
                        <Heading level={3} color={'#707070'}>
                            {translate('prix_enleve')}
                            <span style={{ color: "#59A4F4" }}><strong>{` ${toCurrency(getFirstPayAmount(devis))} `} </strong></span>
                            / {isMonthly ? translate('month') : translate('year')}
                        </Heading>

                    }

                    {submitable &&
                        <Box width={'medium'} justify='center'>
                            <Promo
                                devis={devis}
                                onDevisChange={onDevisChange}
                                product={product}
                            />
                        </Box>
                    }
                    {submitable &&
                        (isPhone(size) ?
                            (<Box width={'full'} justify='center' align="center" gap="small" direction="row">
                                <Box style={{ width: '50%', background: "#59A4F4", height: 60 }} round={{ size: 'medium' }}
                                    justify='center' align="center" direction="row" gap="small"
                                >
                                    <PrimaryButton
                                        label={translate('modifier_button')}
                                        onClick={toStartStep}
                                        background={'#59A4F4'}
                                    />
                                </Box>
                                <Box style={{ width: '50%', background: "#E92C70", height: 60 }} round={{ size: 'medium' }}
                                    justify='center' align="center" direction="row" gap="small"
                                >
                                    <PrimaryButton
                                        label={`${translate('massure_pour')} ${toCurrency(getFirstPayAmount(devis))}`}
                                        onClick={checkout}
                                    />
                                </Box>
                            </Box>) :
                            <Box width={'medium'} justify='center' align='center' gap='medium'>
                                <PrimaryButton
                                    label={translate('modifier_button')}
                                    onClick={toStartStep}
                                    background={'#59A4F4'}
                                />
                                <PrimaryButton
                                    label={`${translate('massure_pour')} ${toCurrency(getFirstPayAmount(devis))}`}
                                    onClick={checkout}
                                />
                            </Box>)
                    }
                </Box>
            </Box>)
            }
        </ResponsiveContext.Consumer>
    );
}

export default Recap;